/** User-facing copy for OpenClaw / channel pairing failures. */

export function openclawPairingMessage(openclaw) {
  if (!openclaw?.error) {
    return "OpenClaw is configured but this workspace is not paired yet. Approve the Sellyx device in the OpenClaw Control UI pairing queue, then refresh this page.";
  }
  const err = String(openclaw.error).toLowerCase();
  if (openclaw.pairing_required || err.includes("pairing") || err.includes("not approved")) {
    return "Sellyx is not approved on the OpenClaw gateway yet. Open the OpenClaw Control UI, approve the pending device for this workspace, then try again.";
  }
  return openclaw.error;
}

export function pairingUserMessage(error, fallback = "Couldn't start channel pairing") {
  const code = String(error?.code || "").toLowerCase();
  if (code === "pairing_required" || code === "pairing_unavailable") {
    return (
      "Sellyx is not approved on the OpenClaw gateway yet. "
      + "Open the OpenClaw Control UI, approve the pending device for this workspace, "
      + "then retry WhatsApp pairing."
    );
  }
  if (code === "whatsapp_channel_not_configured" || code === "whatsapp_plugin_missing") {
    return (
      "WhatsApp is not configured on your OpenClaw gateway yet. "
      + "Install or enable the WhatsApp extension, then retry."
    );
  }
  if (code === "openclaw_schema_mismatch") {
    return "OpenClaw gateway version mismatch — contact your administrator.";
  }
  const msg = String(error?.message || "");
  const lower = msg.toLowerCase();
  if (lower.includes("pairing required") || lower.includes("not approved")) {
    return (
      "Sellyx is not approved on the OpenClaw gateway yet. "
      + "Open the OpenClaw Control UI, approve the pending device for this workspace, "
      + "then retry WhatsApp pairing."
    );
  }
  if (lower.includes("web login provider is not available")) {
    return "WhatsApp channel is not available on your OpenClaw gateway. Enable the plugin and retry.";
  }
  return msg || fallback;
}

export function pairingErrorDescription(error) {
  const code = String(error?.code || "").toLowerCase();
  if (code === "openclaw_schema_mismatch") {
    return "OpenClaw gateway version mismatch — check server configuration.";
  }
  if (code === "whatsapp_plugin_missing" || code === "whatsapp_channel_not_configured") {
    return "Install or enable the WhatsApp extension in OpenClaw, then retry.";
  }
  if (code === "pairing_unavailable" || code === "pairing_required") {
    return "Approve the Sellyx device in the OpenClaw Control UI pairing queue, then retry WhatsApp pairing.";
  }
  const msg = String(error?.message || "").toLowerCase();
  if (msg.includes("pairing required") || msg.includes("not approved")) {
    return "Approve the Sellyx device in the OpenClaw Control UI pairing queue, then retry.";
  }
  return undefined;
}
